import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=6c98a4fd&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c98a4fd')) {
      api.createRecord('6c98a4fd', component.options)
    } else {
      api.reload('6c98a4fd', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=6c98a4fd&", function () {
      api.rerender('6c98a4fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YrbaQGYvq7Qq/JS/comp/openstreetmap.vue"
export default component.exports